import { lazy, useContext, useEffect, useState, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { Route, Switch } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import NotFoundPage_404 from "./pages/_errors/404";
import ThemeContext from './utils/contexts/themeContext';
import Message from "./components/message";
import MessageContext from "./context/messageContext";
import ConfirmContext from './utils/confirmContext';
import FinanceOrder from "./pages/myOrders/components/financeOrder";
import CarBuyOrder from "./pages/myOrders/components/carBuyOrder";
import { SkeletonTheme } from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import SaleAgreement from "./pages/cart/saleAgreement";
import SalesOrder from "./pages/cart/salesOrder";
import PopupWithHeading from "./components/popupWithHeading";
import PurchaseAlertPage from './pages/Alerts/purchaseAlertPage';
import { ServiceOrder } from "./pages/maintenance/components/serviceOrder";
import { useHistory } from "react-router-dom";
import { getData, User_Data_Key } from "./utils/localStorageManager";
import  FixAgreement  from "./pages/fixAgreement";
import  Addationals  from "./pages/addationals";
import  JobCard  from "./pages/jobCard";
import { toast } from "react-toastify";
import { ServiceEvaluationPage } from "./pages/serviceEvaluation";
import SpareParts from "./pages/cart/SpareParts";
import SparePartsSalesPage from "./pages/sparePartsSales";
const Pages = () => {
    const themeMode = useContext(ThemeContext);
    const { t: trans, i18n } = useTranslation(["mobileHeading", "new", 'error']);
    const dir = i18n?.language === 'en' ? false : true;
    const pageDir = 'language-' + i18n?.language;
    const [themeValue, setThemeValue] = useState(themeMode);
    const [messageObj, setMessageObj] = useState({
        show: false,
        imagePath: '/assets/images/delivery.svg',
        title: ''
    });

    useEffect(() => {
        setThemeValue(themeMode);
    }, [themeMode]);
    const [dataCar, setDataCar] = useState({});
    const [showPopup, setShowPopup] = useState(false);
    const [dataPopup, setDataPopup] = useState({});
    const [dataFinalPopup, setDataFinalPopup] = useState({});
    const [showFinalPopup, setShowFinalPopup] = useState(false);
    const handleReset = () => {
        setShowPopup(false);
        setDataPopup({});
    };

    const handlePopup = (car) => {
        console.log("handlePopup");
        setDataPopup(car);
        setShowPopup(true);

    };

    const [confirmObj, setConfirmObj] = useState({
        title: 'عنوان رسالة التاكيد',
        subTitle: null,
        image: null,
        backGround: null,
        displayConfirm: false,
        isHyper: false,
        isNew: false,
        brand: null,
        type: null,
        cartDetails: null,
        defaultColorID: null,
        modelYear: null,
        colors: [{ text: '1', value: '1' }],
        carOrder: null,
        ColorsModel: []
    });


    // to open the confim
    const onShow = (data) => {
        // let val = { ...confirmObj, ...data };
        // setConfirmObj(val);

        const isLogin = getData('isAuthenticated')
        if (!isLogin) {
            toast.error("يرجى تسجيل الدخول اولا ");
            return;
        }
        const cleanData = JSON.parse(getData(User_Data_Key, true));
        if (!cleanData.custID) {
            toast.error("حسابك غير معتمد");
            return;
        }

        if (data?.popupType == "serviceOrder") {

            setOptionTitle("طلب خدمة صيانه")
            setDataPopup(data);
            setOptionType(2);

        } else {

            setOptionTitle("شراء المركبة")
            setDataPopup(data);
            setOptionType(0);
        }

        setShowPopup(true);
    };

    // to close the confirm
    const onClose = () => {
        setConfirmObj({
            title: 'عنوان رسالة التاكيد',
            subTitle: null,
            image: null,
            backGround: null,
            displayConfirm: false,
            isHyper: false,
            isNew: false,
            brand: null,
            type: null,
            cartDetails: null,
            defaultColorID: null,
            modelYear: null,
            colors: [{ text: '1', value: '1' }],
            carOrder: null,
            ColorsModel: []
        })

        setDataPopup({});
        setShowPopup(false);
    };

    // to notify the message to show or hide
    const showMessage = (props) => {
        setMessageObj({ ...messageObj, ...props });
    };

    const onSuccessCarBuyOrder = (data) => {
        console.log("onSuccessCarBuyOrder:", data);
        if (data.buyType == "order" && data.paymentType == "finance") {
            setDataPopup(data);
            setOptionTitle("طلب تمويل مركية")
            setOptionType(1);
            setShowPopup(true);
        } else if (data.buyType == "online" && data.paymentType == "cash") {
            // showFinalMessage(data);


        }
    };
    const showFinalMessage = (data) => {


        console.log("showFinalMessage:", data);
        setShowPopup(false);
        setOptionType(-1);
        //-----------------
        setDataFinalPopup(data);
        setOptionTitle("")
        setShowFinalPopup(true);
    };
    const [optionType, setOptionType] = useState(null);
    const [optionTitle, setOptionTitle] = useState('');

    const popupSectionCallback = useCallback(() => {

        let fragment = <></>;
        switch (optionType) {
            case 0:

                fragment = <CarBuyOrder onSuccess={data => onSuccessCarBuyOrder(data)} dataCar={dataPopup} />


                break;
            case 1:

                fragment = <FinanceOrder
                    dataCar={dataPopup}
                    onSuccess={data => showFinalMessage(data)}
                />


                break;
            case 2:

                fragment = <ServiceOrder
                    data={dataPopup}


                />


                break;

        }
        return <div className="my-20 p-5">
            {fragment}
        </div>;
    }, [optionType, optionTitle, dataPopup]);

    const history = useHistory();
    const alertClosed = (data) => {

        history.goBack();
    };



    return (
        <div className={`App  unselectable  theme-${themeValue} ${pageDir}`} >
            <SkeletonTheme
                baseColor={themeValue == "dark" ? "#39393D" : ""} highlightColor={themeValue == "dark" ? "#737376" : "#c9c9c9"}
            >
                <MessageContext.Provider value={{ messageObj, showMessage }}>

                    <ConfirmContext.Provider value={{ onShow, onClose }}>
                        <Switch>

                            <Route exact path={'/saleAgreement'} component={SaleAgreement} />
                            <Route exact path={'/salesOrder/:number'} component={SalesOrder} />
                            <Route exact path={'/fixAgreement/:number'} component={FixAgreement} />
                            <Route exact path={'/addationals/:number'} component={Addationals} />
                            <Route exact path={'/ServiceEvaluation/:number'} component={ServiceEvaluationPage} />
                            <Route exact path={'/jobCard/:number'} component={JobCard} />
                            <Route exact path={'/spareParts/:number'} component={SpareParts} />
                            <Route exact path={'/sparePartsSales/:number'} component={SparePartsSalesPage} />
                            <NotFoundPage_404 />
                        </Switch>
                        <ToastContainer
                            toastStyle={{ margin: '0 3rem' }}
                            position="bottom-center"
                            autoClose={5000}
                            hideProgressBar={false}
                            newestOnTop={false}
                            closeOnClick
                            rtl={dir}
                            pauseOnFocusLoss
                            draggable
                            pauseOnHover
                        />


                        <PopupWithHeading
                          className={"popup-container-auto"}
                            show={showPopup}
                            title={optionTitle}
                            onStatusChange={(status) => {
                                handleReset();
                            }}
                        >

                            {popupSectionCallback()}

                        </PopupWithHeading>
                        <PurchaseAlertPage show={showFinalPopup} data={dataFinalPopup} handleClosed={() => {

                            setShowFinalPopup(false)
                        }} />
                    </ConfirmContext.Provider>
                    <Message {...messageObj} />

                </MessageContext.Provider>
            </SkeletonTheme>
        </div>
    );
}
export default Pages;